import { Component, type ReactNode } from 'react';
import { auth } from './firebase';
import { tell } from './errors';

/*
 * index.html's own catcher wipes the page and prints the error, which is right
 * while the modules are loading -- there is no app yet to say anything else --
 * and was wrong for the rest of the session: it never stood down, so any
 * error at all once the app was running, even a harmless one from Google's
 * scripts, replaced the whole app with "Givi Den failed to start". That is
 * almost certainly what Ethan saw. Once the app has drawn, it stands down,
 * and an error is only reported.
 */
export function markBooted(): void {
  (window as Window & { __giviBooted?: boolean }).__giviBooted = true;
}

/**
 * What a crash in a screen leaves instead of a blank page: a way back, and
 * a report of what happened, which the error listener never sees because
 * React catches it first.
 */
export class Crash extends Component<{ children: ReactNode }, { crashed: boolean }> {
  state = { crashed: false };

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  componentDidCatch(error: unknown) {
    const uid = auth.currentUser?.uid;
    if (uid) void tell(uid, error, 'error');
  }

  render() {
    if (!this.state.crashed) return this.props.children;
    return (
      <div className="crash" role="alert">
        <span className="crash-title">Something went wrong</span>
        <span className="crash-line">It has been reported. Reloading usually puts it right.</span>
        <button type="button" className="btn" onClick={() => window.location.reload()}>
          Reload
        </button>
      </div>
    );
  }
}
